import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function ServicesEditorial() {
  return (
    <section className="bg-bone py-24 lg:py-36">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-7 rv">
            <div className="text-eyebrow text-amber mb-5">— 002 • Disciplines</div>
            <h2 className="font-display-tight text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-ink max-w-3xl text-balance">
              One team. <span className="italic font-display">Every detail.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 rv">
            <p className="text-ink-soft text-lg leading-relaxed max-w-md ml-auto">
              From planning drawings to the final snag, every discipline sits under one roof. A single senior partner owns your project from first sketch to final key.
            </p>
          </div>
        </div>

        {/* Editorial service list — hover reveals image */}
        <div className="border-t border-line">
          {SERVICES.map((s, i) => (
            <Link key={s.slug} to={`/services/${s.slug}`}
              className="group relative block border-b border-line py-7 lg:py-9 transition-colors rv"
              style={{ transitionDelay: `${i * 40}ms` }}>
              <div className="grid grid-cols-12 items-center gap-6">
                <div className="col-span-2 md:col-span-1 text-eyebrow text-ink/40">{s.number}</div>
                <div className="col-span-7 md:col-span-6">
                  <h3 className="font-display-tight text-3xl md:text-5xl text-ink leading-none group-hover:text-amber transition-colors">
                    {s.title}
                  </h3>
                </div>
                <div className="hidden md:block col-span-3 text-ink-soft text-[15px] leading-relaxed">
                  {s.blurb.slice(0, 90)}…
                </div>
                <div className="col-span-3 md:col-span-2 flex items-center justify-end gap-3">
                  <span className="hidden lg:inline-block text-eyebrow text-ink/40 group-hover:text-amber transition-colors">{s.tag}</span>
                  <span className="h-11 w-11 border border-ink/20 group-hover:bg-amber group-hover:border-amber flex items-center justify-center transition-colors">
                    <ArrowUpRight className="w-4 h-4 group-hover:text-ink transition-transform group-hover:rotate-45" />
                  </span>
                </div>
              </div>
              {/* Hover image */}
              <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-[360px] aspect-[4/5] opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all duration-500 z-20">
                <img src={s.image} alt="" className="w-full h-full object-cover shadow-2xl" loading="lazy" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
